document.addEventListener('DOMContentLoaded', function () {

	mejs.i18n.language('fr');

	var mediaElements = document.querySelectorAll('audio'), i, total = mediaElements.length;

	for (i = 0; i < total; i++) {
		new MediaElementPlayer(mediaElements[i], {
			stretching: 'auto',
		});
	}

});